export default defineNuxtPlugin(async (_) => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value

  const { update, $t } = useTranslation()

  await update(locale)

  return {
    provide: {
      t: $t,
    },
  }
})
